import React from "react";
import Navbar from "./Navbar";
import "./FoodInfo.css";

function FoodInfo() {
  return (
    <div className="foodInfo">
      <Navbar />
      <h1>Coming</h1>
      <h1>soon</h1>
      <img
        src="https://image.freepik.com/free-vector/burger-illustration-with-eyeglasses-food-illustration_169533-62.jpg"
        alt=""
      />
    </div>
  );
}

export default FoodInfo;
